export default __webpack_public_path__ + "static/media/icon-cash.812e5c3a.svg";